import { Project } from "../../lib/api/projects";

interface ProjectHeaderProps {
  project: Project;
  onCreateTask: () => void;
  onOpenSettings: () => void;
}

export function ProjectHeader({
  project,
  onCreateTask,
  onOpenSettings,
}: ProjectHeaderProps) {
  return (
    <div className="flex justify-between items-start">
      <div>
        <h1 className="text-3xl font-bold mb-2">{project.name}</h1>
        <div className="text-gray-500 mb-2">Project Key: {project.key}</div>
        {project.description && (
          <p className="text-gray-600 mb-4">{project.description}</p>
        )}
      </div>
      <div className="flex gap-4">
        <button
          onClick={onCreateTask}
          className="bg-blue-500 hover:bg-blue-600 text-white px-4 py-2 rounded"
        >
          Create Task
        </button>
        <button
          onClick={onOpenSettings}
          className="border border-gray-300 hover:border-gray-400 px-4 py-2 rounded"
        >
          Project Settings
        </button>
      </div>
    </div>
  );
}
